import {
    ADMIN_COUNTRY_MAPPING_COMPARE_SUCCESS,
    ADMIN_COUNTRY_MAPPING_COMPARE_FAILED,
    LOADING_ADMIN_COUNTRY_MAPPING_COMPARE,
    NETWORK_ERROR_ADMIN_COUNTRY_MAPPING_COMPARE,
    RESET_ADMIN_COUNTRY_MAPPING_COMPARE,

} from "../types/index";
import { adminServices } from "../../config/axios";

const resetCountryMappingCompareListAdmin = () => {
    return { type: RESET_ADMIN_COUNTRY_MAPPING_COMPARE };
};

const countryMappingCompareListAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMIN_COUNTRY_MAPPING_COMPARE });
    await adminServices
        .post("countryMappingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminCountryMappingCompareListsuccess(res.data));
                    break;
                default:
                    dispatch(adminCountryMappingCompareListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMIN_COUNTRY_MAPPING_COMPARE,
                payload: err
            });
        });
};


function adminCountryMappingCompareListsuccess(data) {
    return {
        type: ADMIN_COUNTRY_MAPPING_COMPARE_SUCCESS,
        payload: data
    };
}
function adminCountryMappingCompareListFailed(data) {
    return {
        type: ADMIN_COUNTRY_MAPPING_COMPARE_FAILED,
        payload: data
    };
}

export { countryMappingCompareListAdmin, resetCountryMappingCompareListAdmin }
